// @flow
import ApiClient from 'utils/ApiClient';
import Dispatcher from 'dispatcher';
import * as ActionTypes from 'action_types/ScreeningParamsActionTypes';
import ScreeningParamsModel from 'models/ScreeningParams';

class ScreeningParams {
  getScreeningParams(data = {}) {
    ApiClient.get({
      path: '/screening_params.json',
      data: data,
      success: response => {
        Dispatcher.dispatch({
          type: ActionTypes.LIST_SCREENING_PARAMS,
          listScreeningParams: response.map(
            screeningParam => new ScreeningParamsModel(screeningParam)
          ),
          keyParam: data.name
        });
      }
    });
  }
}

export default new ScreeningParams();
